(function () {
  function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
  }

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const phoneTrigger = target.closest('[data-phone-trigger]');
    if (phoneTrigger) {
      if (isMobileDevice()) return;

      const href = phoneTrigger.getAttribute('href');
      if (!href || !href.startsWith('tel:')) return;

      event.preventDefault();
      window.location.href = href;
      return;
    }
  });
})();
